/**
 * Adviva GA Event Track
 */

window.GA = {

    init: function () {
        this.eventClick();
        this.eventSubmit();
        $(document).bind('gform_post_render', this.eventAjaxSuccess());
    },

    /**
     * Click Manager
     */
    eventClick: function () {
        for (var item in window.GA_VARIABLES.click) {
            let singleItem = window.GA_VARIABLES.click[item];

            $(document).on('click', singleItem.selector, function () {
                if (singleItem.eventAction == '$page_url') {
                    singleItem.eventAction = document.location.href;
                }
                if (singleItem.eventLabel == '$page_url') {
                    singleItem.eventLabel = document.location.href;
                }

                window.dataLayer.push({
                    'event': singleItem.event !== undefined ? singleItem.event : 'GAevent',
                    'eventCategory': singleItem.eventCategory,
                    'eventAction': singleItem.eventAction,
                    'eventLabel': singleItem.eventLabel,
                    'nonInteraction': singleItem.nonInteraction !== undefined ? singleItem.nonInteraction : false,
                });
            });
        }
    },

    /**
     * Submit Manager
     */
    eventSubmit: function () {
        for (var item in window.GA_VARIABLES.submit) {
            let singleItem = window.GA_VARIABLES.submit[item];

            $(singleItem.selector).on('submit', function (e) {
                e.preventDefault();

                const callBack = function () {
                    $(e.currentTarget).off('submit').submit();
                };

                if (singleItem.eventAction == '$page_url') {
                    singleItem.eventAction = document.location.href;
                }
                if (singleItem.eventLabel == '$page_url') {
                    singleItem.eventLabel = document.location.href;
                }

                window.dataLayer.push({
                    'event': singleItem.event !== undefined ? singleItem.event : 'GAevent',
                    'eventCategory': singleItem.eventCategory,
                    'eventAction': singleItem.eventAction,
                    'eventLabel': singleItem.eventLabel,
                    'nonInteraction': singleItem.nonInteraction !== undefined ? singleItem.nonInteraction : false,
                    'eventCallback': function () {
                        callBack();
                    },
                    'eventTimeout': 2000,
                });

            });
        }
    },

    /**
     * Ajax Complete
     */
    eventAjaxSuccess: function () {
        $(document).bind("gform_confirmation_loaded", function (e, form_id) {
            for (var item in window.GA_VARIABLES.ajaxSuccess) {
                let singleItem = window.GA_VARIABLES.ajaxSuccess[item];
                if( form_id === singleItem.formId){
                    window.dataLayer.push({
                        'event': singleItem.event !== undefined ? singleItem.event : 'GAevent',
                        'eventCategory': singleItem.eventCategory,
                        'eventAction': singleItem.eventAction,
                        'eventLabel': singleItem.eventLabel,
                        'nonInteraction': singleItem.nonInteraction !== undefined ? singleItem.nonInteraction : false,
                    });
                }
            }
        });
    },

};

(function ($) {
    if (window.GA_VARIABLES.debug) {
        // remove original dataLayer due to slice error
        window.dataLayer = {
            'push': function (data) {
                if (data.eventCallback) {
                    data.eventCallback();
                }
            },
        };
    }

    window.dataLayer = window.dataLayer ? window.dataLayer : [];

    $(document).ready(function() {
        window.GA.init();
    });

})(jQuery);




// WEBPACK FOOTER //
// ./scripts/ga/ga.js